import axios from "axios";

export const state = {
    loanapplications: [],
};

export const getters = {
    loanapplications: (state) => state.loanapplications,
};

export const mutations = {
    setLoanApplications(state, newValue) {
        state.loanapplications = newValue;
    },
};

export const actions = {
    async fetchLoanApplications({ commit, rootState }) {
        const fyear = rootState.financialyears.currentFinancialYear;

        // ADDED: Guard to prevent fetching if fyear is not yet loaded
        if (!fyear) return;

        await axios.get(`/loans/applications/${fyear}`).then((res) => {
            commit("setLoanApplications", res.data.loan_applications);
        });
    },
};
